
import type { JobDataResponse, JobStatusResponse } from "../types/JobStatusResponse";
import type { MusicJobStatusPayload } from "../types/MusicJobStatus";
import { getAuthHeader } from "../utils/helper";
import { apiService } from "./base-api-service/base-api-service";
import { endPoints, getJobManagerServiceEndPoint } from "./base-url/api-constants";

class JobManagerService {
  JobManagerService(url: any) {
    return getJobManagerServiceEndPoint(url);
  }

  getJobStatus(jobId: string): Promise<JobStatusResponse> {
    const endpoint = this.JobManagerService(
      `${endPoints.jobManagerService.JOB_STATUS.replace(":operationId", jobId)}`
    );
    return apiService.get(endpoint);
  }

  postJobStatus(data: MusicJobStatusPayload): Promise<JobDataResponse> {
    const apiEndpoint = this.JobManagerService(`${endPoints.jobManagerService.POST_JOB}`);
    return apiService.post<JobDataResponse>(apiEndpoint, data, getAuthHeader());
  }

  updateJobStatus(jobId: string, status: number): Promise<JobDataResponse> {
    const endpoint = this.JobManagerService(
      `${endPoints.jobManagerService.JOB_STATUS.replace(":operationId", jobId)}`
    );
    return apiService.patch<JobDataResponse>(endpoint, { status }, getAuthHeader());
  }
}

export default new JobManagerService();
